// extracted by mini-css-extract-plugin
export default {"root":"main-layout_root__kCKLL","sidebar":"main-layout_sidebar__aElN1","content":"main-layout_content__1mxC0","contentCart":"main-layout_contentCart__rQRdY"};